<section>
    <h2>{{ 'we_are_all_over_poland' | translate }}</h2>

    <div class="clients">
        <div *ngFor="let item of clients">
            <img src="{{ item.img }}" alt="{{ item.alt }}" />
        </div>
    </div>
</section>
